import React from "react";

function SvgIcMapPoi100(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M16 23h5v-5.003h-5V23zm7-7v10h-9v-1.803c0-2.319-1.791-4.198-4-4.198-.26 0-.512.029-.757.08L9 20.135V16h14zM9.5 21.998c1.381 0 2.5 1.075 2.5 2.4v1.6H7v-1.6c0-1.325 1.119-2.4 2.5-2.4zM23 5v9H9a7 7 0 017-7c1.382 0 2.669.404 3.753 1.095L20 8.26V5h3z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi100;
